import React, { useState } from 'react';
import '../assets/styles/Contact.scss';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SendIcon from '@mui/icons-material/Send';
import { useLanguage } from '../i18n/LanguageProvider';

function Contact() {
  const { t } = useLanguage();
  const whatsappNumber = '201204246538';
  const [form, setForm] = useState({
    name: '',
    email: '',
    projectType: '',
    message: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!form.name || !form.email || !form.projectType || !form.message) {
      return;
    }

    const projectTypeLabel = form.projectType ? t(`contact.form.projectTypeOptions.${form.projectType}`) : '';
    const summary = `${t('contact.title')}\n${t('contact.form.nameLabel')}: ${form.name}\n${t('contact.form.emailLabel')}: ${form.email}\n${t('contact.form.projectTypeLabel')}: ${projectTypeLabel}\n${t('contact.form.messageLabel')}: ${form.message}`;
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(summary)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-bg" aria-hidden />
      <div className="contact-grid">
        <div className="contact-left glass-card">
          <p className="eyebrow">{t('contact.eyebrow')}</p>
          <h1>{t('contact.title')}</h1>
          <p className="subtitle">
            {t('contact.subtitle')}
          </p>
          <div className="contact-cards">
            <div className="info-card">
              <div className="icon-wrap"><PhoneIphoneIcon /></div>
              <div>
                <p className="label">{t('contact.cards.phoneLabel')}</p>
                <p className="value">{t('contact.cards.phoneValue')}</p>
              </div>
            </div>
            <div className="info-card">
              <div className="icon-wrap"><AlternateEmailIcon /></div>
              <div>
                <p className="label">{t('contact.cards.emailLabel')}</p>
                <p className="value">{t('contact.cards.emailValue')}</p>
              </div>
            </div>
            <div className="info-card">
              <div className="icon-wrap"><LocationOnIcon /></div>
              <div>
                <p className="label">{t('contact.cards.locationLabel')}</p>
                <p className="value">{t('contact.cards.locationValue')}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-right glass-card">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="field-group">
              <label htmlFor="name">{t('contact.form.nameLabel')}</label>
              <input
                id="name"
                name="name"
                type="text"
                placeholder={t('contact.form.namePlaceholder')}
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="field-group">
              <label htmlFor="email">{t('contact.form.emailLabel')}</label>
              <input
                id="email"
                name="email"
                type="email"
                placeholder={t('contact.form.emailPlaceholder')}
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="field-group">
              <label htmlFor="projectType">{t('contact.form.projectTypeLabel')}</label>
              <select
                id="projectType"
                name="projectType"
                value={form.projectType}
                onChange={handleChange}
                required
              >
                <option value="" disabled>{t('contact.form.projectTypePlaceholder')}</option>
                <option value="web">{t('contact.form.projectTypeOptions.web')}</option>
                <option value="mobile">{t('contact.form.projectTypeOptions.mobile')}</option>
                <option value="desktop">{t('contact.form.projectTypeOptions.desktop')}</option>
                <option value="dashboard">{t('contact.form.projectTypeOptions.dashboard')}</option>
                <option value="automation">{t('contact.form.projectTypeOptions.automation')}</option>
                <option value="other">{t('contact.form.projectTypeOptions.other')}</option>
              </select>
            </div>

            <div className="field-group">
              <label htmlFor="message">{t('contact.form.messageLabel')}</label>
              <textarea
                id="message"
                name="message"
                placeholder={t('contact.form.messagePlaceholder')}
                rows={5}
                value={form.message}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="primary-btn">
              {t('contact.form.submit')}
              <SendIcon fontSize="small" />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;